"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadResources = exports.initI18n = exports.I18nextProvider = exports.Trans = exports.useTranslation = void 0;
/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
const i18next_1 = __importDefault(require("i18next"));
const react_i18next_1 = require("react-i18next");
const i18next_browser_languagedetector_1 = __importDefault(require("i18next-browser-languagedetector"));
const i18next_chained_backend_1 = __importDefault(require("i18next-chained-backend"));
const i18next_pseudo_1 = __importDefault(require("i18next-pseudo"));
const format_1 = __importDefault(require("./format"));
const utils_1 = require("./utils");
const backend_1 = require("./backend");
var react_i18next_2 = require("react-i18next");
Object.defineProperty(exports, "useTranslation", { enumerable: true, get: function () { return react_i18next_2.useTranslation; } });
Object.defineProperty(exports, "Trans", { enumerable: true, get: function () { return react_i18next_2.Trans; } });
Object.defineProperty(exports, "I18nextProvider", { enumerable: true, get: function () { return react_i18next_2.I18nextProvider; } });
const defaultFallbackOrder = ['en-GB', 'fallback'];
let globalConfig = null;
const initI18n = (translation, config, defaultLang, languageToPseudo, extraFormatter) => __awaiter(void 0, void 0, void 0, function* () {
    globalConfig = Object.assign({}, config);
    const initOptions = {
        // Default resources
        resources: {
            fallback: { translation },
        },
        /*
          Namespace option : https://www.i18next.com/principles/fallback#namespace-fallback
          "Besides defining multiple namespaces to load from, you also can set fallback namespaces.
          Thus, if a key to translate isn't found in the given namespace, it will look it up in the indicated fallbacks."
        */
        defaultNS: 'translation',
        ns: ['translation'],
        fallbackNS: ['translation'],
        debug: globalConfig.debug || false,
        //* Language options */
        load: 'all',
        preload: defaultLang
            ? [defaultLang, ...defaultFallbackOrder]
            : defaultFallbackOrder,
        fallbackLng: defaultLang
            ? [defaultLang, ...defaultFallbackOrder]
            : defaultFallbackOrder,
        lowerCaseLng: false,
        cleanCode: true,
        //* Interpolation */
        interpolation: {
            escapeValue: false,
            format: (value, format, lng, options) => (0, format_1.default)(value, format, lng, options, extraFormatter),
        },
        //* Load Resources*/
        partialBundledLanguages: true,
        //* React options */
        react: {
            bindI18n: 'languageChanged',
            useSuspense: false,
            transSupportBasicHtmlNodes: true,
        },
        // Pseudo localization
        postProcess: languageToPseudo ? ['pseudo'] : false,
        // Load translation externally
        backend: ((0, backend_1.backendOptions)(globalConfig.bucketBase, globalConfig.productName, globalConfig.store || 'localStorage', globalConfig.expirationTime || 7 * 24 * 60 * 60 * 1000, globalConfig.cache)),
    };
    yield i18next_1.default
        .use(new i18next_pseudo_1.default({ enabled: !!languageToPseudo, languageToPseudo }))
        .use(i18next_chained_backend_1.default)
        .use(i18next_browser_languagedetector_1.default)
        .use(react_i18next_1.initReactI18next)
        .init(initOptions);
    return i18next_1.default;
});
exports.initI18n = initI18n;
// Based on : https://www.i18next.com/overview/api#addresourcebundle
// REACT_APP_PRODUCT_ID=MySurvey
const loadResources = ({ id: projectId, displayName: projectName, languages, disabledLanguages = [], namespaces = ['translation'], }) => __awaiter(void 0, void 0, void 0, function* () {
    if (!globalConfig) {
        console.error('Configuration not found. You must first call initI18n.');
        return;
    }
    if (!languages || !languages.length) {
        console.error('Missing languages');
        return;
    }
    const localLanguages = languages
        // Remove disabled languages
        .filter((l) => !disabledLanguages.includes(l))
        // First load the current language
        .sort((lng) => (i18next_1.default.language !== lng ? 1 : -1));
    /** Loads all languages */
    for (const lng of localLanguages) {
        /** Loads all namespaces */
        for (const ns of namespaces) {
            console.log(`Loading translations for ${globalConfig.productName}, language ${lng}, namespace ${ns}`);
            // Product translation are handled by backend plugin on init to speed up fetching
            // await loadResourceBundle(`${baseProductUrl}/${ns}.json`, lng, ns);
            if (projectName) {
                yield (0, utils_1.loadResourceBundle)(i18next_1.default, `${globalConfig.bucketBase}/initiatives/${encodeURI(projectName)}/${encodeURI(globalConfig.productName)}/i18n/${lng}/${ns}.json`, lng, ns);
            }
            // Fetch dynamic resources
            let baseUrl = `${globalConfig.apiBase}/loadI18n/${lng}/${ns}?product_name=${globalConfig.productName}`;
            if (projectId) {
                baseUrl += `&project_id=${projectId}`;
            }
            yield (0, utils_1.loadResourceBundle)(i18next_1.default, baseUrl, lng, ns, true);
        }
        // If I'm loading the current language force refresh
        if (i18next_1.default.language === lng) {
            i18next_1.default.changeLanguage(lng);
        }
    }
});
exports.loadResources = loadResources;
exports.default = i18next_1.default;
